import * as React from 'react';
import { observer } from 'mobx-react';
import './syncWithLabDialog.scss';

export interface ISyncWithLabDialogProps {
    unconfirmedUseAutoSync: boolean;
    onClose: () => void;
    onConfirm: (useAutoSync: boolean) => void;
}

export const turnOnDialogTitle = 'Turn On Insight Lab Sync';
export const turnOffDialogTitle = 'Turn Off Insight Lab Sync';
// tslint:disable-next-line:max-line-length
export const turnOnDialogContent = 'Warning: you are about to turn on auto-syncing with Insight Lab. All manual adjustments to this budget will be lost once data syncs.';
// tslint:disable-next-line:max-line-length
export const turnOffDialogContent = 'Insight Lab will no longer automatically update budget data in Team. You will be able to manually override budget fields once the sync is off.';
export const turnOnDialogConfirmButton = 'Turn On Sync';
export const turnOffDialogConfirmButton = 'Turn Off Sync';

@observer
export default class SyncWithLabDialog extends React.Component<ISyncWithLabDialogProps> {
    constructor(props: ISyncWithLabDialogProps) {
        super(props);
        this.handleClickClose = this.handleClickClose.bind(this);
        this.handleClickConfirm = this.handleClickConfirm.bind(this);
    }

    render(): React.ReactNode {
        return (
            <div className="pxl-modal confirmation-modal">
                <div className="pxl-modal__content">
                    <div className="pull-right">
                        <button
                            className="close no-btn-style"
                            onClick={this.handleClickClose}
                        >
                            <i className="icon-cancel pxl-text-c11-5" />
                        </button>
                    </div>
                    <div className="modal-header">
                        <h2>
                            {this.getDialogTitle()}
                        </h2>
                    </div>
                    <div className="modal-content">
                        <p>{this.getDialogContent()}</p>
                    </div>
                    <div className="modal-action">
                        <button
                            onClick={this.handleClickConfirm}
                            className="pxl-btn pxl-btn--primary"
                        >
                            {this.getConfirmButtonText()}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    private getDialogTitle(): string {
        const { unconfirmedUseAutoSync } = this.props;
        return unconfirmedUseAutoSync ? turnOnDialogTitle : turnOffDialogTitle;
    }

    private getDialogContent(): string {
        const { unconfirmedUseAutoSync } = this.props;
        return unconfirmedUseAutoSync ? turnOnDialogContent : turnOffDialogContent;
    }

    private getConfirmButtonText(): string {
        const { unconfirmedUseAutoSync } = this.props;
        return unconfirmedUseAutoSync ? turnOnDialogConfirmButton : turnOffDialogConfirmButton;
    }

    private handleClickClose(): void {
        this.props.onClose();
    }

    private handleClickConfirm(): void {
        this.props.onConfirm(this.props.unconfirmedUseAutoSync);
        this.props.onClose();
    }
}